import { createFileRoute } from '@tanstack/react-router';
import { SearchResults } from '../../features/search/SearchResults';

export interface SearchRouteSearch {
  q?: string;
}

/** Owned by G25 (plan.md S0), alongside reports.tsx. Reads the header search
 * box's `?q=` param (src/components/Shell.tsx's `GlobalSearch`) and renders real
 * fuzzy-search results grouped by entity kind. */
export const Route = createFileRoute('/_authenticated/search')({
  validateSearch: (search: Record<string, unknown>): SearchRouteSearch => ({
    q: typeof search.q === 'string' ? search.q : undefined,
  }),
  component: SearchPage,
});

function SearchPage() {
  const { q } = Route.useSearch();
  return <SearchResults initialQuery={q} />;
}
